import React, { useEffect, useState } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    Autocomplete
} from '@mui/material'
import axios from 'axios'
import apiUrl from '../../../configs/constant';
import { useToast } from '../../../components/ToastProvider'
import { Controller, useForm } from 'react-hook-form';

interface Props {
    id: any
    open: boolean
    tabel?: any
    onClose: () => void
    onReload: () => void
}

const formatNumber = (value: string) => {
    const raw = value.replace(/[^0-9,]/g, '')
    const parts = raw.split(',')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return parts.join(',')
}

export default function DialogPenerimaan({
    id,
    open,
    tabel,
    onClose,
    onReload
}: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    const [listAkun, setListAkun] = useState<any[]>([])

    useEffect(() => {
        if (!open) return

        reset()
        getAkun()
    }, [open])

    const getAkun = () => {

        let url = apiUrl.apiUrl + '/acc/account/list-akun-biaya'

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data

                    setListAkun(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        reset
    } = useForm({
        defaultValues: {
            akun: '',
            total: '',
            keterangan: ''
        }
    })

    const onSubmit = (data: any) => {
        const payload = {
            accarr_id: id,
            accapp_id: id,
            accinv_id: id,
            accakun_id: data.akun?.id,
            total: data.total.replace(/\./g, ''),
            keterangan: data.keterangan
        }

        let url = ''
        if (tabel === 'accarr') {
            url = apiUrl.apiUrl + '/acc/arr/add-biaya-lainnya'
        }
        else if (tabel === 'accapp') {
            url = apiUrl.apiUrl + '/acc/app/add-biaya-lainnya'
        } else if (tabel == 'accinv') {
            url = apiUrl.apiUrl + '/acc/invoice/add-biaya-lainnya'
        }

        axios.post(url, payload, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            showToast(res.data.message, 'success')

            onReload()
            onClose()
        })
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Tambah Biaya Lainnya
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12}>
                            <Controller
                                name="akun"
                                control={control}
                                rules={{ required: 'Akun wajib dipilih' }}
                                render={({ field }) => (
                                    <Autocomplete
                                        {...field}
                                        value={field.value || null}
                                        options={listAkun}
                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                        getOptionLabel={(o) => o?.nama+" | Saldo : "+o?.saldo}
                                        onChange={(_, val) => {
                                            field.onChange(val)
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Akun"
                                                error={!!errors.akun}
                                                helperText={errors.akun?.message as string}
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="total"
                                control={control}
                                rules={{ required: 'Total wajib diisi' }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Total"
                                        fullWidth
                                        inputProps={{ inputMode: 'numeric' }}
                                        onChange={(e) =>
                                            field.onChange(formatNumber(e.target.value))
                                        }
                                        error={!!errors.total}
                                        helperText={errors.total?.message as string}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="keterangan"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Keterangan"
                                        multiline
                                        rows={2}
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button fullWidth variant="contained" type="submit">
                        SIMPAN
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}

